import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/lib/theme-context";

export function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggle } = useTheme();
  return (
    <button
      type="button"
      aria-label="Toggle theme"
      onClick={toggle}
      className={`relative inline-flex h-8 w-16 items-center rounded-full border border-border bg-card p-1 shadow-sm transition-colors hover:bg-muted ${className ?? ""}`}
    >
      <span
        className={`absolute left-1 top-1 h-6 w-6 rounded-full bg-primary shadow-sm transition-transform duration-200 ease-out ${theme === "dark" ? "translate-x-8" : "translate-x-0"}`}
      />
      <span className="flex w-full items-center justify-between px-1.5">
        <Sun className="h-3.5 w-3.5 text-muted-foreground" aria-hidden="true" />
        <Moon className="h-3.5 w-3.5 text-muted-foreground" aria-hidden="true" />
      </span>
    </button>
  );
}
